import gql from 'graphql-tag';

import {
	createResourceMutationDefinitions,
	listResourceQueryDefinitions,
	updateResourceMutationDefinitions,
	viewResourceQueryDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';

export const CUSTOMERS_LIST_QUERY = gql`
	query Customers($first: Int, $after: String) {
		customers(first: $first, after: $after) {
			nodes {
				customerId
				displayName
				firmName
				firstName
				lastName
				email
				isActive
				isCompany
				marketingOptIn
				customerCategory {
					customerCategoryId
					description
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const CUSTOMERS_AUTOCOMPLETE_QUERY = gql`
	query CustomersAutocomplete(
		$where: CustomerViewModelFilterInput
		$order: [CustomerViewModelSortInput!]
		$first: Int
	) {
		customers(where: $where, order: $order, first: $first) {
			nodes {
				customerId
				displayName
				firmName
				firstName
				lastName
				email
				isCompany
				createdAt
				isActive
				isDeleted
			}
		}
	}
`;

export const CUSTOMER_LIST_ITEM_QUERY = gql`
	query CustomerListItem($id: Ulid!) {
		customer(customerId: $id) {
				customerId
				isCompany
				firmName
				firstName
				lastName
				email
				displayName
				marketingOptIn
				fiscalNumber
				taxOffice
				billingLegalName
				billingTradeName
				billingCountryCode
				isActive
			customerCategory {
				description
			}
		}
	}
`;

export const CUSTOMER_QUERY = gql`
	query Customer($id: Ulid!) {
		customer(customerId: $id) {
			customerId
			displayName
			firmName
			firstName
			lastName
			email
			fiscalNumber
			taxOffice
			billingLegalName
			billingTradeName
			billingCountryCode
			marketingOptIn
			notes
			isActive
			isCompany
			isDeleted
			createdAt
			updatedAt
			activatedAt
			deactivatedAt
			dateOfBirth
			gender
			idNumber
			idType
			nationality
			customerCategoryId
			customerCategory {
				customerCategoryId
				description
			}
			preferredLanguage
			companyRegistrationNumber
			industry
			companySize
			customerContacts {
				customerContactId
				contactTypeId
				contactValue
				label
				isPrimary
				isDeleted
				isVerified
				verifiedAt
				notes
				createdAt
				updatedAt
				contactType {
					contactTypeId
					name
					isActive
				}
			}
			customerAddresses {
				customerAddressId
				addressId
				addressTypeId
				addressType {
					addressTypeId
					name
				}
				address {
					addressId
					streetAddress
					city
					state
					postalCode
					country
				}
			}
			bankDetails {
				bankDetailsId
				bankName
				accountNumber
				accountType
				iban
				bankCode
				branchCode
				branchName
				accountHolderName
				currency
				purpose
				notes
				isPrimary
				isActive
				isDeleted
				isVerified
				verificationMethod
				verifiedAt
				createdAt
				updatedAt
			}
				customerBeneficiaries {
					customerBeneficiaryId
					beneficiaryId
					isActive
					notes
					relationshipType
					isDeleted
					beneficiary {
						customerId
						displayName
						firmName
						firstName
						lastName
						isCompany
					}
				}
			vehicles {
				vehicleId
				plateNumber
				make
				model
				color
				isActive
				vehicleTypeId
				vehicleType {
					vehicleTypeId
					name
				}
			}
		}
	}
`;

export const CUSTOMER_FORM_DATA_QUERY = gql`
	query CustomerFormData {
		customerCategories {
			customerCategoryId
			description
		}
		contactTypes {
			contactTypeId
			name
			isActive
		}
		addressTypes {
			addressTypeId
			name
		}
		vehicleTypes {
			vehicleTypeId
			name
		}
	}
`;

export const CUSTOMER_CREATE_MUTATION = gql`
	mutation CreateCustomer($input: CreateCustomerInput!) {
		createCustomer(input: $input) {
			success
			errorCode
			errorDescription
		}
	}
`;

export const CUSTOMER_UPDATE_MUTATION = gql`
	mutation UpdateCustomer($input: UpdateCustomerInput!) {
		updateCustomer(input: $input) {
			success
			errorCode
			errorDescription
		}
	}
`;

export const CUSTOMER_DELETE_MUTATION = gql`
	mutation DeleteCustomer($input: DeleteCustomerInput!) {
		deleteCustomer(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['customers'] = {
	document: CUSTOMERS_LIST_QUERY,
	dataPath: 'customers.nodes'
};

viewResourceQueryDefinitions['customers'] = {
	document: CUSTOMER_QUERY,
	dataPath: 'customer'
};

createResourceMutationDefinitions['customers'] = {
	document: CUSTOMER_CREATE_MUTATION,
	operation: 'createCustomer',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['customers'] = {
	document: CUSTOMER_UPDATE_MUTATION,
	operation: 'updateCustomer',
	getVariables: variables => ({ input: variables })
};

deleteResourceMutationDefinitions['customers'] = {
	document: CUSTOMER_DELETE_MUTATION,
	operation: 'deleteCustomer',
	getVariables: variables => ({ input: variables })
};

// Query for fetching contracts associated with a specific customer
export const CUSTOMER_CONTRACTS_QUERY = gql`
	query CustomerContracts($customerId: Ulid!) {
		contracts(where: { customerId: { eq: $customerId } }) {
			nodes {
				customerId
				contractId
				beginDate
				endDate
				amount
				simultaneousVehicleLimit
				isActive
			}
		}
	}
`;
